module.exports = __webpack_public_path__ + "img/horizontal_4_4_r_8003.cf9f0852.png";